import type { ComputedRef } from 'vue'

import { useDisciplineStore } from '@stores/discipline'

import amplitudeConfig from '@config/amplitude.json'

import { trackClassroomEvent } from '@tools/amplitude/classroom'

interface ClassroomLearningPlatformReturn {
  label: string
  isVisible: ComputedRef<boolean>
  handleClick: () => void
}

const BUTTON_NAME = 'to_learning_platform'

export const useClassroomLearningPlatform = (): ClassroomLearningPlatformReturn => {
  const disciplineStore = useDisciplineStore()

  const label = 'Learning platform'

  const isVisible = computed<boolean>(() => {
    return disciplineStore.hasLearningPlatformAccess && !!disciplineStore.getLearningPlatformUrl
  })

  const handleClick = (): void => {
    const url = disciplineStore.getLearningPlatformUrl
    if (!url) return

    trackClassroomEvent(amplitudeConfig.events.clickButton, {
      button_name: BUTTON_NAME,
      text: label,
    })

    window.open(url, '_blank', 'noopener')
  }

  return {
    label,
    isVisible,
    handleClick,
  }
}
